/* Copyright (C) 2018 TeselaGen Biotechnology, Inc. */
import React, { useRef } from "react";
import { Intent, Button, Classes } from "@blueprintjs/core";
import { noop } from "lodash";
import classNames from "classnames";

function DialogFooter(_ref) {
  var hideModal = _ref.hideModal,
      loading = _ref.loading,
      submitting = _ref.submitting,
      onBackClick = _ref.onBackClick,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? noop : _ref$onClick,
      secondaryAction = _ref.secondaryAction,
      _ref$intent = _ref.intent,
      intent = _ref$intent === void 0 ? Intent.PRIMARY : _ref$intent,
      secondaryIntent = _ref.secondaryIntent,
      _ref$backText = _ref.backText,
      backText = _ref$backText === void 0 ? "Back" : _ref$backText,
      _ref$secondaryText = _ref.secondaryText,
      secondaryText = _ref$secondaryText === void 0 ? "Cancel" : _ref$secondaryText,
      additionalButtons = _ref.additionalButtons,
      className = _ref.className,
      _ref$secondaryClassNa = _ref.secondaryClassName,
      secondaryClassName = _ref$secondaryClassNa === void 0 ? "" : _ref$secondaryClassNa,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? "Submit" : _ref$text,
      disabled = _ref.disabled,
      containerClassname = _ref.containerClassname,
      noCancel = _ref.noCancel;
  var r = useRef();
  return /*#__PURE__*/React.createElement("div", {
    ref: r,
    className: classNames(Classes.DIALOG_FOOTER, containerClassname)
  }, /*#__PURE__*/React.createElement("div", {
    className: Classes.DIALOG_FOOTER_ACTIONS
  }, onBackClick && /*#__PURE__*/React.createElement(Button // intent={secondaryIntent}
  , {
    className: Classes.MINIMAL + " " + secondaryClassName,
    text: backText,
    onClick: onBackClick
  }), !noCancel && /*#__PURE__*/React.createElement(Button, {
    intent: secondaryIntent,
    className: Classes.MINIMAL + " " + secondaryClassName,
    text: secondaryText,
    onClick: secondaryAction || hideModal || function () {
      try {
        r.current.closest(".bp3-dialog").querySelector(".bp3-dialog-close-button").click();
      } catch (error) {
        console.error("error closing dialog:", error);
      }
    }
  }), additionalButtons, /*#__PURE__*/React.createElement(Button, {
    text: text,
    intent: intent,
    type: "submit",
    className: className,
    onClick: onClick,
    disabled: disabled,
    loading: loading || submitting
  })));
}

export default DialogFooter;